import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f1a62b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-client-page" }
const _hoisted_2 = { class: "select-client-content" }
const _hoisted_3 = { class: "clients-title" }
const _hoisted_4 = { class: "clients-search-row" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "client-list" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_view_header = _resolveComponent("view-header")!
  const _component_OrderHeaderChangeActions = _resolveComponent("OrderHeaderChangeActions")!
  const _component_back_and_cancel_footer = _resolveComponent("back-and-cancel-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_view_header, {
      text: _ctx.$t('cashier.header.select-business-client')
    }, null, 8, ["text"]),
    _createVNode(_component_OrderHeaderChangeActions, {
      productId: _ctx.productId,
      selected: 2
    }, null, 8, ["productId"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("cashier.label.select-business-client")), 1),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: _ctx.$t('cashier.placeholder.search'),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event))
        }, null, 8, _hoisted_5), [
          [_vModelText, _ctx.searchText]
        ]),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchText = ''))
        }, _toDisplayString(_ctx.$t("cashier.label.clear")), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientsToShow, (client) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "client-item",
            key: client.id
          }, [
            _createElementVNode("div", null, _toDisplayString(client.name), 1),
            _createElementVNode("div", null, _toDisplayString(client.businessClientTypeName), 1),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: ($event: any) => (_ctx.setClient(client))
              }, _toDisplayString(_ctx.$t("cashier.label.select")), 9, _hoisted_7)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_back_and_cancel_footer)
  ]))
}